import { GridColumn } from "@ucl/library";

/**
 * Default column configuration for related tasks view
 * These columns are optimized for the compact related tasks display
 */
export const relatedTasksColumns: Record<string, GridColumn> = {
  taskExecutionTypeName: new GridColumn({
    field: "taskExecutionTypeName",
    headerText: "Task Type",
    type: "string",
    width: 150,
    maxWidth: 150,
  }),
  taskTemplateName: new GridColumn({
    field: "taskTemplateName",
    headerText: "Task Name",
    type: "string",
    width: 150,
    maxWidth: 150,
  }),
  id: new GridColumn({
    field: "id",
    headerText: "Identifier",
    type: "string",
    visible: false,
  }),
};
